/** Traductions modal ajout produit (FR / AR) */
export const addProductModalFr = {
  titleDish: 'Ajouter un Plat',
  titlePurchase: "Ajouter Produit à l'Achat",
  titleInventory: "Ajouter Produit à l'Inventaire",
  titlePage: 'Nouveau produit',
  back: 'Retour',
  sectionClassification: 'Classification',
  sectionIdentity: 'Identité',
  sectionCommerce: 'Unité, carton & prix',
  sectionMedia: 'Image',
  addToList: 'Ajouter à la liste',
  queueTitle: 'À ajouter',
  queueEmpty: 'Ajoutez un produit à gauche pour le voir ici.',
  queueCount: '{{count}} produit(s)',
  saveAll: 'Enregistrer tout',
  removeFromQueue: 'Retirer',
  clearQueue: 'Vider la liste',
  queuedSuccess: 'Produit ajouté à la liste',
  submitDish: 'Ajouter le Plat',
  submitPurchase: "Ajouter à l'Achat",
  submitInventory: "Ajouter à l'Inventaire",
  nameSuggestions: 'Suggestions — cliquer pour choisir :',
  invalidFileType: 'Erreur de Fichier',
  selectValidImage: 'Veuillez sélectionner un fichier image valide',
  fileTooLarge: 'Erreur de Taille',
  imageMaxSize: "La taille de l'image doit être inférieure à 7 Mo",
  catalogDataLoaded: 'Données du produit chargées depuis le catalogue',
  dishNameRequired: 'Nom du plat requis',
  sellingPriceRequired: 'Prix de vente requis',
  selectMenuCategory: 'Choisissez une catégorie menu',
  productNameRequired: 'Nom du produit requis',
  categoryRequired: 'Veuillez sélectionner une catégorie',
  menuCategory: 'Catégorie menu',
  menuCategoryCustom: 'Autre (saisie manuelle)',
  menuCategoryCustomPlaceholder: 'Ex. Plats du jour, Spécialités…',
  typeOptional: 'Type (optionnel)',
  typeCustom: 'Autre (saisie manuelle)',
  typeCustomPlaceholder: 'Ex. Spécial maison…',
  generalType: '— Général —',
  includedStockSection: 'Articles stock inclus',
  includedStockHint:
    'Ex. boisson du menu : déduit du stock à la vente POS (pas un second article de vente).',
  includedStockProduct: 'Article stock',
  includedStockQty: 'Qté / plat',
  includedStockAdd: 'Ajouter un article',
  includedStockRemove: 'Retirer',
  includedStockEmpty: 'Aucun article — vente du plat sans abattement stock',
  includedStockSelect: '— Choisir —',
  includedStockManagedByRecipe:
    'Ce plat a une recette ACTIVE (« {{name}} » v{{version}}). La consommation stock est pilotée par la recette — éditez-la dans Restaurant → Recettes.',
  includedStockOpenRecipes: 'Ouvrir les recettes',
  sellOnPos: 'Vendre au POS',
  sellOnPosHint:
    'Si coché, cet ingrédient apparaît au POS (ex. boissons). Sinon cuisine uniquement.',
  defaultStockLocation: 'Lieu stock (Bar / Cuisine / Grill)',
  defaultStockLocationAuto: '— Auto (boissons→Bar, grill→Grill, cuisine→Cuisine) —',
  defaultStockLocationHint:
    'Les lots FIFO et la recette consomment ce lieu. Transférez le stock vers ce lieu après achat.',

  dishName: 'Nom du plat',
  sellingPrice: 'Prix de vente',
  dishImage: 'Image du plat',
  chooseImage: 'Choisir une image',
  cancel: 'Annuler',
  nameRequired: 'Nom *',
  categoryRequiredLabel: 'Catégorie *',
  dash: '—',
  catalog: 'Catalogue',
  importExcel: 'Importer Excel',
  importExcelSuccess: 'Import terminé : {{products}} produit(s) ajouté(s) au catalogue',
  optionalDetails: 'Détails (optionnel)',
  subcategory: 'Sous-catégorie',
  auto: 'Auto',
  autoResolvesTo: '→ {{subcategory}} / {{type}}',
  quickTypePick: 'Rapide :',
  type: 'Type',
  barcode: 'Code-barres',
  barcodeScanHint: 'Scannez un code-barres pour le remplir ici',
  barcodeScanned: 'Code-barres saisi depuis le scanner',
  barcodeExistsWarn: 'Ce code-barres existe déjà sur un autre produit',
  salePrice: 'Prix vente / unité',
  unitsPerPack: 'U. par carton',
  unitsPerPackExample: 'ex : 12',
  sellingPackPrice: 'Prix vente carton',
  sellingPackPriceHint: 'ex : 110 (pas 12×unité)',
  unit: 'Unité de stock',
  picking: 'Cueillette',
  conservation: 'Conservation',
  noExpiry: 'Sans date',
  longConservation: 'Longue',
  mediumConservation: 'Moyenne',
  perishable: 'Périssable',
  image: 'Image',
  chooseImageShort: 'Choisir image',
  catalogAddedSuccess: '{{count}} éléments ajoutés à l\'inventaire',
  confirmCloseTitle: 'Confirmer la fermeture',
  confirmCloseMessage: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer le formulaire ? Toutes les données saisies seront perdues.',
  closeWithoutSave: 'Fermer sans enregistrer',
  draftSaved: 'Brouillon enregistré',
  draftSavedDetail: 'Brouillon enregistré — {{count}} produit(s) en liste',
  draftNothingToSave: 'Rien à enregistrer dans le brouillon',
  draftSaveFailed: 'Impossible d\'enregistrer le brouillon',
  draftSavedAt: 'Brouillon enregistré à {{time}}',
  saveDraftLabel: 'Enregistrer brouillon',
  resumeDraft: 'Reprendre brouillon ({{count}})',
  discardDraft: 'Supprimer brouillon',
  discardDraftDone: 'Brouillon produit supprimé',
  businessIdMissing: 'Entreprise introuvable — brouillon non enregistré'
};

export const addProductModalAr = {
  titleDish: 'إضافة طبق',
  titlePurchase: 'إضافة منتج للشراء',
  titleInventory: 'إضافة منتج للمخزون',
  titlePage: 'منتج جديد',
  back: 'رجوع',
  sectionClassification: 'التصنيف',
  sectionIdentity: 'الهوية',
  sectionCommerce: 'الوحدة والكرتون والسعر',
  sectionMedia: 'الصورة',
  addToList: 'إضافة إلى القائمة',
  queueTitle: 'للإضافة',
  queueEmpty: 'أضف منتجًا من اليسار ليظهر هنا.',
  queueCount: '{{count}} منتج',
  saveAll: 'حفظ الكل',
  removeFromQueue: 'إزالة',
  clearQueue: 'تفريغ القائمة',
  queuedSuccess: 'تمت إضافة المنتج إلى القائمة',
  submitDish: 'إضافة الطبق',
  submitPurchase: 'إضافة للشراء',
  submitInventory: 'إضافة للمخزون',
  nameSuggestions: 'اقتراحات — انقر للاختيار:',
  invalidFileType: 'نوع الملف غير صحيح',
  selectValidImage: 'يرجى اختيار ملف صورة صالح (JPG, PNG, GIF)',
  fileTooLarge: 'حجم الملف كبير جداً',
  imageMaxSize: 'حجم الصورة يجب أن يكون أقل من 7 ميجابايت. يرجى اختيار صورة أصغر',
  catalogDataLoaded: 'تم تحميل بيانات المنتج من الكتالوج بنجاح',
  dishNameRequired: 'اسم الطبق مطلوب',
  sellingPriceRequired: 'سعر البيع مطلوب',
  selectMenuCategory: 'اختر فئة القائمة',
  productNameRequired: 'اسم المنتج مطلوب',
  categoryRequired: 'يرجى اختيار الفئة',
  menuCategory: 'فئة القائمة',
  menuCategoryCustom: 'أخرى (إدخال يدوي)',
  menuCategoryCustomPlaceholder: 'مثال: أطباق اليوم، تخصصات…',
  typeOptional: 'النوع (اختياري)',
  typeCustom: 'آخر (إدخال يدوي)',
  typeCustomPlaceholder: 'مثال: تخصص المنزل…',
  generalType: '— عام —',
  includedStockSection: 'أصناف المخزون المشمولة',
  includedStockHint:
    'مثال: مشروب القائمة — يُخصم من المخزون عند البيع (وليس بيعًا منفصلًا).',
  includedStockProduct: 'صنف المخزون',
  includedStockQty: 'الكمية / طبق',
  includedStockAdd: 'إضافة صنف',
  includedStockRemove: 'إزالة',
  includedStockEmpty: 'لا أصناف — بيع الطبق دون خصم مخزون',
  includedStockSelect: '— اختر —',
  includedStockManagedByRecipe:
    'لهذا الطبق وصفة نشطة (« {{name}} » v{{version}}). خصم المخزون يُدار من الوصفة — عدّلها في المطعم → الوصفات.',
  includedStockOpenRecipes: 'فتح الوصفات',
  sellOnPos: 'بيع في نقطة البيع',
  sellOnPosHint:
    'فعّل للأصناف المباعة كما هي (مشروبات، صلصات…). اتركها معطّلة لمكوّنات المطبخ فقط.',
  defaultStockLocation: 'موقع المخزون (Bar / Cuisine / Grill)',
  defaultStockLocationAuto: '— تلقائي (مشروبات→Bar، grill→Grill، مطبخ→Cuisine) —',
  defaultStockLocationHint:
    'FIFO والوصفة يخصمان من هذا الموقع. انقل المخزون إليه بعد الشراء.',

  dishName: 'اسم الطبق',
  sellingPrice: 'سعر البيع',
  dishImage: 'صورة الطبق',
  chooseImage: 'اختر صورة',
  cancel: 'إلغاء',
  nameRequired: 'الاسم *',
  categoryRequiredLabel: 'الفئة *',
  dash: '—',
  catalog: 'الكتالوج',
  importExcel: 'استيراد Excel',
  importExcelSuccess: 'اكتمل الاستيراد: {{products}} منتج في الكتالوج',
  optionalDetails: 'تفاصيل اختيارية',
  subcategory: 'الفئة الفرعية',
  auto: 'تلقائي',
  autoResolvesTo: '→ {{subcategory}} / {{type}}',
  quickTypePick: 'سريع:',
  type: 'النوع',
  barcode: 'الباركود',
  barcodeScanHint: 'امسح الباركود لملء هذا الحقل',
  barcodeScanned: 'تم إدخال الباركود من الماسح',
  barcodeExistsWarn: 'هذا الباركود موجود بالفعل لمنتج آخر',
  salePrice: 'سعر البيع / وحدة',
  unitsPerPack: 'وحدة/كرتون',
  unitsPerPackExample: 'مثال: 12',
  sellingPackPrice: 'سعر بيع الكرتون',
  sellingPackPriceHint: 'مثال: 110 (ليس 12×الوحدة)',
  unit: 'وحدة المخزون',
  picking: 'الجرد',
  conservation: 'الحفظ',
  noExpiry: 'بدون تاريخ',
  longConservation: 'طويل',
  mediumConservation: 'متوسط',
  perishable: 'قابل للتلف',
  image: 'صورة',
  chooseImageShort: 'اختر صورة',
  catalogAddedSuccess: 'تم إضافة {{count}} عنصر للمخزون',
  confirmCloseTitle: 'تأكيد الإغلاق',
  confirmCloseMessage: 'لديك تغييرات غير محفوظة. هل أنت متأكد من أنك تريد إغلاق النموذج؟ سيتم فقدان جميع البيانات المدخلة.',
  closeWithoutSave: 'إغلاق بدون حفظ',
  draftSaved: 'تم حفظ المسودة',
  draftSavedDetail: 'تم حفظ المسودة — {{count}} منتج في القائمة',
  draftNothingToSave: 'لا يوجد شيء لحفظه في المسودة',
  draftSaveFailed: 'تعذر حفظ المسودة',
  draftSavedAt: 'تم حفظ المسودة في {{time}}',
  saveDraftLabel: 'حفظ المسودة',
  resumeDraft: 'استئناف المسودة ({{count}})',
  discardDraft: 'حذف المسودة',
  discardDraftDone: 'تم حذف مسودة المنتج',
  businessIdMissing: 'المؤسسة غير موجودة — لم تُحفظ المسودة'
};
